/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExpandToLastLevel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M2 2h6v6H6v3h3V9h6v6H9v-2H6v5h10v-2h6v6h-6v-2H4V8H2zm4 4V4H4v2zm12 12v2h2v-2zm-7-7v2h2v-2zm9.333-7v6.692l.983-.922 1.368 1.46-3.35 3.14-3.351-3.14 1.368-1.46.982.922V6H12.5V4z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgExpandToLastLevel as ExpandToLastLevel };
